import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
//import {UserModel} from '../model/FormsEntity/registrationForm';
import { ResponseMessage } from '../model/FormsEntity/response';
import { captchaValidateStatusResponse } from '../model/FormsEntity/captchaValidationStatus';
import { ModuleListResponeModel } from '../model/FormsEntity/moduleListResponeModel';
import { ViewUserModel } from '../model/FormsEntity/ViewUserModel';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
  export class UserManagementService {
    private usersUrl: string;
    private usermanagementUrl: string;


    constructor(private http:HttpClient) {
         //this.usersUrl = 'http://10.8.16.38:9080/dda/';
         this.usersUrl =  environment.baseUrl;
         this.usermanagementUrl = environment.baseUrl + 'usermgmt/';
    }
    public send(data: Object) {
        return this.http.post<captchaValidateStatusResponse>(this.usersUrl + 'validateCaptcha', data);
      }
      public getImage() {
        return this.http.get<any>(this.usersUrl + 'generateCaptcha');
      }
    public getRoleList(){
        return this.http.get<any>(this.usersUrl +'listOfRoles');
    }
    public submitRegistrationForm(userManegament){
        return this.http.post<ResponseMessage>(this.usersUrl +'createUser',userManegament);
    }
    public resetPassword(resetPass){
        return this.http.post<ResponseMessage>(this.usersUrl +'resetPassword',resetPass);
    }
    public forgotPassword(userName){
        return this.http.post<ResponseMessage>(this.usersUrl +'forgotPassword',userName);
    }
    public departmentList(){
        return this.http.get<any>(this.usersUrl +'listOfDepartment');
    }
    public saveDepartmentDetails(deptDetails){
        return this.http.post<ResponseMessage>(this.usersUrl +'saveDepartmentDetails',deptDetails);
    }
    public listOfDepartmentDetails(){
        return this.http.get<any>(this.usersUrl +'listOfDepartmentDetails');
    }
    public getListOfBranch(value){
        return this.http.get<any>(this.usersUrl +'getListOfBranch/' +value);
    }
    public adminUserList(){
        return this.http.get<any>(this.usersUrl +'adminUserList/');
    }
    public adminUserActiveList(){
        return this.http.get<any>(this.usersUrl +'adminUserActiveList/');
    }
    public changePasswordService(changePass){
        return this.http.post<ResponseMessage>(this.usersUrl +'passwordChange',changePass);
    }
    public userList(userModel){        
        return this.http.post<ResponseMessage>(this.usersUrl +'userList',userModel);
    }

    public viewUserDetails(userId){
        //alert(userId)
        //alert("hello viewUserDetails")
        return this.http.post<ViewUserModel>(this.usersUrl + 'viewUser',userId)
      }

    public updateUserDetails(userModel){
        return this.http.post<ResponseMessage>(this.usersUrl +'updateUser',userModel);
    }
    public updateDepartmentDetails(deptModel){
        return this.http.post<ResponseMessage>(this.usersUrl +'updateDepartmentDetails',deptModel);
    }
    public addDepartment(deptModel){
        return this.http.post<ResponseMessage>(this.usersUrl +'addDepartment',deptModel);
    }
    public deactivateUser(userModel){
        return this.http.post<ResponseMessage>(this.usersUrl +'deactivateUser',userModel);
    }
    public deleteBranch(branchModel){
        return this.http.post<ResponseMessage>(this.usersUrl +'deleteBranch',branchModel);
    }
    public editDepartment(deptModel){
        return this.http.post<ResponseMessage>(this.usersUrl +'editDepartment',deptModel);
    }
    public deleteDepartment(deptModel){
        return this.http.post<ResponseMessage>(this.usersUrl +'deleteDepartment',deptModel);
    }
    public getServicesList(){
        return this.http.get<any>(this.usersUrl +'getSericesList/');
    }
    public getModulesName(moduleRequestInputModel){
        return this.http.post<ModuleListResponeModel>(this.usersUrl +'getModuesList',moduleRequestInputModel);
    }

    public getNewModulesName(moduleRequestInputModel){
        return this.http.post<ModuleListResponeModel>(this.usersUrl +'getModuesList1',moduleRequestInputModel);
    }
    public addRoles(data){
        return this.http.post<ResponseMessage>(this.usersUrl +'addRoles',data);
    }

    public editRole(model){
        return this.http.post<ResponseMessage>(this.usersUrl +'editRole',model);
    }
    public deleteRole(model){
        return this.http.post<ResponseMessage>(this.usersUrl +'deleteRole',model);
    }
    public getAppMenuList(){
        return this.http.get<any>(this.usersUrl +'getAppMenuList/');
    }

    public getNewAppMenuList(){
        return this.http.get<any>(this.usersUrl +'getAppMenuList1');
    }

    public addDesignation(model){
        return this.http.post<ResponseMessage>(this.usermanagementUrl +'createRole',model);
    }

    public getDesigntionList(){
        return this.http.get<any>(this.usermanagementUrl +'getRoles');
    }

    public updateDesignation(model){
        return this.http.put<ResponseMessage>(this.usermanagementUrl +'updateRole',model);
    }

    public addBranch(model){
        return this.http.post<ResponseMessage>(this.usermanagementUrl +'createBranch',model);
    }

    public getBranch(){
        return this.http.get<any>(this.usermanagementUrl +'getBranches');
    }

    public getRoleDetail(value){
        return this.http.get<any>(this.usermanagementUrl +'getRoleDetail/' +value);
    }

    public updateBranch(model){
        return this.http.put<ResponseMessage>(this.usermanagementUrl +'updateBranch',model);
    }

    public getRoles(value){
        return this.http.get<any>(this.usermanagementUrl +'getRoles/' +value);
    }

    public getBranches(value){
        return this.http.get<any>(this.usermanagementUrl +'getBranches/' +value);
    }

    public addZone(model){
        return this.http.post<ResponseMessage>(this.usermanagementUrl +'createZone',model);
    }

    public getZone(){
        return this.http.get<any>(this.usermanagementUrl +'getZones');
    }

    public getZoneByDept(id){
        return this.http.get<any>(this.usermanagementUrl +'getZones/'+id);
    }

    public updateZone(model){
        return this.http.put<ResponseMessage>(this.usermanagementUrl +'updateZone',model);
    }

    public createDivision(model){
        return this.http.post<ResponseMessage>(this.usermanagementUrl +'createDivision',model);
    }

    public updateDivision(model){
        return this.http.put<ResponseMessage>(this.usermanagementUrl +'updateDivision',model);
    }

    public getDivision(){
        return this.http.get<any>(this.usermanagementUrl +'getDivisions');
    }

    public getDivisionByZone(id){
        return this.http.get<any>(this.usermanagementUrl +'getDivisions/'+id);
    }

    public createUser(model){
        console.log(model)
        return this.http.post<ResponseMessage>(this.usermanagementUrl +'createUser',model);
    }

    public updateUser(model){
        console.log(model)
        return this.http.put<ResponseMessage>(this.usermanagementUrl +'updateUser',model);
    }

    public searchUser(roleId,deptId,userName): Observable<any>{
        const params = new HttpParams()
        .set('roleId', roleId)
        .set('deptId', deptId)
        .set('userName', userName);
        return this.http.get<any>(this.usermanagementUrl +'searchUser',{params});
    }

    public searchUsersByRole(deptId,roleId): Observable<any>{
        const params = new HttpParams()
        .set('deptId', deptId)
        .set('roleId', roleId);
        return this.http.get<any>(this.usermanagementUrl +'searchUsersByRole',{params});
    }

    public getRoleByDeptId(deptId){
        return this.http.get<any>(this.usermanagementUrl +'getPHRoles/' +deptId);
    }

    public getMstRole(){
        return this.http.get<any>(this.usermanagementUrl +'getRoles');
    }

    public getMstBranch(){
        return this.http.get<any>(this.usermanagementUrl +'getBranches');
    }
}